"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CoreScatterPlot = void 0;
var tslib_1 = require("tslib");
// (C) 2007-2018 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
var BaseChart_1 = require("../_base/BaseChart");
var CoreScatterPlot = /** @class */ (function (_super) {
    tslib_1.__extends(CoreScatterPlot, _super);
    function CoreScatterPlot() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CoreScatterPlot.prototype.render = function () {
        return react_1.default.createElement(BaseChart_1.BaseChart, tslib_1.__assign({ type: "scatter" }, this.props));
    };
    return CoreScatterPlot;
}(react_1.default.PureComponent));
exports.CoreScatterPlot = CoreScatterPlot;
//# sourceMappingURL=CoreScatterPlot.js.map